import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'workflow-details-dialog',
    template: `
    <h2 mat-dialog-title>{{data.status}} Workflows for {{data.recruiter}}</h2>
    <div mat-dialog-content>
      @if (data.workflows.length === 0) {
        <div class="no-data">
          No workflow details available.
        </div>
      }
      @if (data.workflows.length > 0) {
        <table class="table table-striped">
          <thead>
            <tr>
              <th>State ID</th>
              <th>Candidate</th>
              <th>Role</th>
              <th>Client</th>
              <th>Notes</th>
              <th>Status</th>
              <th>Last Update</th>
            </tr>
          </thead>
          <tbody>
            @for (workflow of data.workflows; track workflow) {
              <tr>
                <td>{{workflow.state_id}}</td>
                <td>{{workflow.candidate_name || workflow.candidate_id}}</td>
                <td>{{workflow.role_title || workflow.role_id}}</td>
                <td>{{workflow.client}}</td>
                <td>{{workflow.notes}}</td>
                <td>{{workflow.latest_status}}</td>
                <td>{{workflow.last_update | date:'medium'}}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </div>
    `,
    styles: [`
    .no-data {
      padding: 20px;
      text-align: center;
      font-style: italic;
    }
    table {
      width: 100%;
    }
  `],
    standalone: false
})
export class WorkflowDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<WorkflowDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
